import { render, staticRenderFns } from "./TintometricoVincularEanModal.vue?vue&type=template&id=60b8d4d0"
import script from "./TintometricoVincularEanModal.vue?vue&type=script&lang=js"
export * from "./TintometricoVincularEanModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports